<template>
<page-wrapper>
  <v-row dense>
    <v-col cols="2">
      <v-select v-model="month" :items="availableMonths" label="Month" @change="fetchReport"></v-select>
    </v-col>
    <v-spacer></v-spacer>
    <right-hand-buttons v-if="month">
      <submitted document="payroll" :detail="month"></submitted>
      <mileage-report :month="month"></mileage-report>
      <file-download end-point="/staff-ot/export" :params="{ month }"
                     @click="$refs.downloadHistory.fetch()">
        Payroll
      </file-download>
      <download-history ref="downloadHistory" document="payroll" :date="month" :detail="month"></download-history>
    </right-hand-buttons>
  </v-row>
  <section v-for="[user, days] in report" :key="user">
    <h3 class="ml-2">{{ user }}</h3>
    <overtime-table :days="days"></overtime-table>
  </section>
</page-wrapper>
</template>

<script>
import PageWrapper from '../components/ui/PageWrapper'
import * as api from '../api'
import OvertimeTable from '../components/payroll/OvertimeTable'
import FileDownload from '../components/export/FileDownload'
import MileageReport from '../components/payroll/MileageReport'
import RightHandButtons from '../components/ui/RightHandButtons'
import DownloadHistory from '../components/ui/DownloadHistory'
import Submitted from '../components/ui/Submitted'

export default {
  name: 'StaffOT',
  components: {
    Submitted,
    DownloadHistory,
    RightHandButtons,
    MileageReport,
    FileDownload,
    OvertimeTable,
    PageWrapper
  },
  data() {
    return {
      month: null,
      report: [],
      availableMonths: []
    }
  },
  methods: {
    async fetchReport() {
      this.$router.push({
        name: this.$route.name,
        query: {
          month: this.month
        }
      }).catch(e => {})
    }
  },
  async beforeRouteUpdate(to, from, next) {
    const { query } = to
    if (!query.month) {
      query.month = this.availableMonths[0].value
    }
    this.report = await api.get('/staff-ot', query)
    this.month = query.month
    next()
  },
  async mounted() {
    this.availableMonths = await api.get('/shoot/months')
    if ('month' in this.$route.query) {
      const { month } = this.$route.query
      this.month = month
    } else {
      this.month = this.availableMonths[0].value
    }
    const query = { month: this.month }
    this.report = await api.get('/staff-ot', query)
  }
}
</script>

<style scoped lang="scss">
section {
  margin-bottom: 2rem;
}
</style>
